module.exports = __webpack_public_path__ + "tel_bg1.png?926379872529be6c9f9a234b9b13f5d7";


//////////////////
// WEBPACK FOOTER
// ./static/assets/tel_bg1.png
// module id = 544
// module chunks = 0